import main from './main.vue'
const commonCode= {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonCode